import { render, staticRenderFns } from "./AllocationList.vue?vue&type=template&id=1d2d1285&"
import script from "./AllocationList.vue?vue&type=script&lang=js&"
export * from "./AllocationList.vue?vue&type=script&lang=js&"
import style0 from "./AllocationList.vue?vue&type=style&index=0&id=1d2d1285&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports